/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.SwapGroups {
  "use strict";

  export class swapGroupsContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
    swapServiceDetail: Model.SwapGroupService;
    upgradeSwapGroupServiceDetail: Model.SwapGroupService;
    serviceFilterCriteria: any;
    upgradeServiceFilterCriteria: any;

    constructor(appSettings: Meevo.Components.Common.IAppSettings,
      dataService: Meevo.Components.BaseClasses.IDataService,
      modalService: Meevo.Components.Modal.IModalService,
      identityService: Meevo.Components.Common.IIdentityService,
      loggingService: Meevo.Components.Logging.ILoggingService,
      securityChecker: Meevo.Components.Common.ISecurityService,
      trackingService: Meevo.Components.Tracking.ITrackingService,
      protected $translate: angular.translate.ITranslateService,
      protected busyService: Meevo.Components.Busy.IBusyService) {

      super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);

      this.baseEndpoint = appSettings.API_ENDPOINTS.swapGroup;
      this.sectionTemplatePath = "app/plugins/swapGroups/sectionViews/";

      // TODO: Review per conversation if we should use the "main" tab key or overall module key as the base of the CRUD action keys
      this.buildCrudSecurityKeys(this.securityKeys.DATA_SWAPGROUP_TAB_MAIN);
      this.entityType = 'SwapGroup';
      this.updatedSelectedServieList();
      this.deleteConfirmationMessageKey = this.$translate.instant('LABEL_SWAPGROUP_INACTIVE_DELETE_CONFIRM_MESSAGE');
    }

    initializeSections(): void {
     if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_SWAPGROUP_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
        this.sections.push(new MainSection(0, "SECTION_SWAP_GROUP_MAIN", "main.html", true, false, this.appSettings.API_ENDPOINTS.swapGroup, "",
            this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.SwapGroupMain, null, this.securityKeys.DATA_SWAPGROUP_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
     }
    }

    initializeHeader(model: any): void {
      this.headerContent = model.displayName;
      this.businessTypeDetail = model.businessTypeDetail;
      this.updatedSelectedServieList();
      }

    isApplicationModeCO(): boolean {
        return this.identityService.inCentralOfficeMode();
    }

    isMarketPricingEnabled() {
        return this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_MARKETPRICING + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
    }

    addService(): void {
        var swapGroup = this.castModel<Model.SwapGroup>();
        if (Model.Guard.isNothing(swapGroup) || Model.Guard.isNothing(this.swapServiceDetail)) return;

        if (this.swapServiceDetail.isProductUsageEnabled && this.swapServiceDetail.packageServiceRedemptionEnum == Model.PackageServiceRedemptionEnum.ProductUnit) {
            this.modalService.alert("MESSAGE_SERVICE_PRODUCT_UNIT", Components.Modal.ModalTranslationModes.Translate);
            return;
        }
        if (_.find(swapGroup.swapServices, (ec) => { return ec.id === this.swapServiceDetail.id }) === undefined) {
            {
                this.swapServiceDetail.service_TId = this.swapServiceDetail.id;
                swapGroup.swapServices.unshift(this.swapServiceDetail);
                this.swapServiceDetail = undefined;
            }
        }
        this.updatedSelectedServieList();
    }

    addUpgradeService(): void {
        var upgradeSwapGroup = this.castModel<Model.SwapGroup>();
        if (Model.Guard.isNothing(upgradeSwapGroup) || Model.Guard.isNothing(this.upgradeSwapGroupServiceDetail)) return;

        if (this.upgradeSwapGroupServiceDetail.packageServiceRedemptionEnum == Model.PackageServiceRedemptionEnum.ProductUnit && this.upgradeSwapGroupServiceDetail.isProductUsageEnabled) {
            this.modalService.alert("MESSAGE_SERVICE_PRODUCT_UNIT", Components.Modal.ModalTranslationModes.Translate);
            return;
        }
        if (_.find(upgradeSwapGroup.upgradeSwapGroupServiceList, (ec) => { return ec.id === this.upgradeSwapGroupServiceDetail.id }) === undefined) {
            {
                this.upgradeSwapGroupServiceDetail.service_TId = this.upgradeSwapGroupServiceDetail.id;
                upgradeSwapGroup.upgradeSwapGroupServiceList.unshift(this.upgradeSwapGroupServiceDetail);
                this.upgradeSwapGroupServiceDetail = undefined;
            }
        }
        this.updatedSelectedServieList();
    }

    removeService(index: number): void {
      var swapGroup = this.castModel<Model.SwapGroup>();
      if (Model.Guard.isNothing(swapGroup))
        return;
      swapGroup.swapServices.splice(index, 1);
      this.updatedSelectedServieList();
    }
    removeUpdgradeService(index: number): void {
      var swapGroup = this.castModel<Model.SwapGroup>();
      if (Model.Guard.isNothing(swapGroup))
        return;
      swapGroup.upgradeSwapGroupServiceList.splice(index, 1);
      this.updatedSelectedServieList();
    }

    updatedSelectedServieList(): void {
      var swapGroup = this.castModel<Model.SwapGroup>();
      var fullList = null;
      var itemId = null;
      if (Model.Guard.isSomething(swapGroup)) {
        // Collect ids from both service collections
        var selectedIdList = Model.Guard.isNothing(swapGroup.swapServices) || swapGroup.swapServices.length < 1
          ? null : _.pluck(swapGroup.swapServices, 'id');
        var upgradedIdList = Model.Guard.isNothing(swapGroup.upgradeSwapGroupServiceList) || swapGroup.upgradeSwapGroupServiceList.length < 1
          ? null : _.pluck(swapGroup.upgradeSwapGroupServiceList, 'id');
        // Build full exclusion list
        fullList = Model.Guard.isSomething(selectedIdList) || Model.Guard.isSomething(upgradedIdList)
          ? _.union(selectedIdList, upgradedIdList) : null;
        itemId = swapGroup.id;
      }
      // Build paging criteria
      this.serviceFilterCriteria = {
          ExcludeSwapGroupId: itemId,
          ExcludeIdList: fullList
      };

        this.upgradeServiceFilterCriteria = {
        ExcludeSwapGroupId: itemId,
        ExcludeIdList: fullList,
        ExcludeSwapGroup: false
        };
    }

    get isLocationReadonly(): boolean {
      var swapGroup = this.castModel<Model.SwapGroup>();
      return this.isReadonly && (!this.isOwning || this.asLocationId !== swapGroup.homeLocationId);
    }

    save(): angular.IPromise<any> {
      var swapGroup = this.castModel<Model.SwapGroup>();
      var checkPrice: boolean = false;
      if (Model.Guard.isSomething(swapGroup.upgradeSwapGroupServiceList)) {
        _.each(swapGroup.upgradeSwapGroupServiceList, item => {
          if (item.additionalCost <= 0) {
            checkPrice = true;
          }
        });
        if (checkPrice) {
          this.busyService.stop();
          this.modalService.alert("LABEL_UPGRADE_SWAP_SERVICES_PRICE_REQUIRED",
            Components.Modal.ModalTranslationModes.Translate);
          return;
        }
      }
      if (swapGroup.objectState === Model.ObjectStateEnum.Inactive) {
        this.busyService.stop();
        this.modalService.warning(this.deleteConfirmationMessageKey, 0, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
          .then(result => {
            if (result) {
              return super.save().then((data: any) => {
                this.swapServiceDetail = undefined;
                swapGroup.swapServices = [];
                swapGroup.upgradeSwapGroupServiceList = [];
                this.updatedSelectedServieList();
              });
            }
          });
      }
      else {
        return super.save().then((data: any) => {
          this.swapServiceDetail = undefined;
        });
      }
    }

    postCopy(): void {
      super.postCopy();
      let model = this.castModel<Model.SwapGroup>();
      model.displayName = undefined;
      model.description = undefined;
      model.swapServices = [];
      model.upgradeSwapGroupServiceList = [];
    }

      openMarketsModal(service: Model.SwapGroupService) {
        if (!this.isReadonly) {
            return
        }

        let params = {
            swapGroupId: this.castModel<Model.SwapGroup>().id,
            serviceId: service.service_TId
        }
        this.dataService.customMethodData("api/SwapGroupServicePrice/List/", "GET", null, params).then((res) => {
            let data = res.data;
            if (data && data.length) {
                let options: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: "app/components/controls/swapGroupMarkets/swapGroupMarkets.template.html",
                    controller: "meevo.components.controls.swapGroupMarkets.SwapGroupMarketsController",
                    controllerAs: "vm",
                    bindToController: true,
                    locals: {
                        options: {
                            data,
                            swapGroupServiceId: service.swapGroupService_TId,
                            serviceName: service.displayName,
                            serviceShortcut: service.shortcut
                        }
                    }
                }

                this.modalService.showCustom(options).then((res) => {
                     
                    if (res && res.defaultMarket) {
                        const defaultMarket = this.castModel<Model.SwapGroup>().upgradeSwapGroupServiceList.find((item) => item.service_TId == res.defaultMarket.service_TId)
                        defaultMarket.additionalCost = res.defaultMarket.additionalCost
                }
            });
            }
        })
    }
  }
}